import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "../components/Logo";
import { api, formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("wcs_token", data.access_token);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-5" data-testid="admin-login">
      <div className="noise-overlay" />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-white p-8 shadow-2xl">
        <Logo />
        <div className="mt-8 flex items-center gap-2 text-gold">
          <Lock className="h-4 w-4" />
          <span className="text-xs font-bold uppercase tracking-[0.2em]">Admin Access</span>
        </div>
        <h1 className="mt-2 font-display text-3xl font-extrabold text-navy">Sign in</h1>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-navy">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
              className="w-full rounded-xl border border-navy/15 px-4 py-3 focus:border-gold" placeholder="admin@wilsoncouriersolutions.com" />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-navy">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
              className="w-full rounded-xl border border-navy/15 px-4 py-3 focus:border-gold" placeholder="••••••••" />
          </div>
          {error && <p className="text-sm font-medium text-red-600" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-navy py-3.5 font-semibold text-white transition-transform hover:scale-[1.01] disabled:opacity-60">
            {loading && <Loader2 className="h-5 w-5 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
